export default __webpack_public_path__ + "EUt_navigation.html";